// const baseUrl = "https://schoolwebapplication.azurewebsites.net/api/";
// const baseUrl = "http://localhost:9000/";

// export const baseUrl="${baseUrl}" //this is for staging
// export const baseUrl="https://dev-apis.varskart.com/api/" //this is for staging
// export const baseUrl="http://glareapis.growcrmpro.com/api/" //this is for staging

export const baseUrl="https://apis.varskart.com/api/" // this is for production

const APP_SETTINGS = {
  API_PATH: {
    userLogin: baseUrl + "Account/LoginUser",
    teacherRegister: baseUrl + "Account/RegisterTeacher",
    principalRegister: baseUrl + "Account/RegisterPrincipal",
    studentRegister: baseUrl + "Account/RegisterStudent",
    getAllStudents: baseUrl + "Account/getAllStudents",
    getAllTeachers: baseUrl + "Account/getAllTeachers",
    getAllPrincipals: baseUrl + "Account/getAllPrincipals",
    getAllMarks: baseUrl + "Account/getAllMarks",
    updateStudentMarks: baseUrl + "Account/UpdateMarks",
    deleteStudentMark: baseUrl + "Account/DeleteMarks",
    addStudentMarks: baseUrl + "Account/AddMarks",
    marksProofRequest: baseUrl + "Account/RequestMarksProof",
    uploadDocumentAgainstRequest: baseUrl + "Account/UploadProofFile",
    approveMarksRequest: baseUrl + "Account/ApproveMarksRequest",
    getAllMarksRequest: baseUrl + "Account/GetAllRequests",

    // generateBlog: baseUrl + "/generate_blog_from_prompt",
    generateBlog: baseUrl + "getSearchData",
    user: baseUrl + "getUsersData",
    getUsersByLoginId: baseUrl + "getUsersByLoginId",
    addUser: baseUrl + "createNewUser",
    deleteUser: baseUrl + "delete",
    updateUser: baseUrl + "updateUser",
    getBlogsByUser: baseUrl + "get/blogByloginId",
    createTask: baseUrl + "createTask",
    createProject: baseUrl + "createProject",
    createTeam: baseUrl + "createTeam",
    getAllTeams: baseUrl + "getAllTeams",
    editTeam: baseUrl + "editTeam",
    editTask: baseUrl + "editTask",
    deleteTeam: baseUrl + "deleteTeam",
    editProject: baseUrl + "editProject",
    editSalleryResource: baseUrl + "editSalleryResource",
    deleteSalleryResource: baseUrl + "deleteSalleryResource",
    deleteProject: baseUrl + "deleteProject",
    getAllProject: baseUrl + "getAllProject",
    getAllTeamsByoginID: baseUrl + "getAllTeamsByLoginID",
    getAllgenerateBlogRequest: baseUrl + "getAllTasks",
    getGenerateBlogRequestByLoginId: baseUrl + "getTasksByLoginId",
    getTasksByProjectManager: baseUrl + "getTasksByProjectManager",
    blogChangestatus: baseUrl + "changeBlogStatus",
    deleterequest: baseUrl + "deleteResource",
    deletTask: baseUrl + "deletTask",
    createNewSalleryResource: baseUrl + "createNewSalleryResource",
    getAllSalleryResources: baseUrl + "getAllSalleryResources",
    projectProgressData: baseUrl + "projectProgressData",
    getTasksByTreamLeadResurces: baseUrl + "getTasksByTreamLeadResurces",
  },
};
export const CONTACT_TYPES = [
  {
    lookupId: 201,
    type: 'AddressType',
    text: 'Home',
    value: 'Home',
  },
  {
    lookupId: 202,
    type: 'AddressType',
    text: 'Office',
    value: 'Office',
  },
  {
    lookupId: 203,
    type: 'AddressType',
    text: 'Fried',
    value: 'Friend',
  },
  {
    lookupId: 204,
    type: 'AddressType',
    text: 'Other',
    value: 'Other',
  },

  {
    lookupId: 205,
    type: 'AddressType',
    text: 'Billing',
    value: 'Billing',
  },
  {
    lookupId: 206,
    type: 'AddressType',
    text: 'Shipping',
    value: 'Shipping',
  },
];
export const PAYMENT_TYPE = [
  {
    lookupId: 601,
    type: 'PaymentType',
    text: 'Cash On Delivery',
    value: 'Cash On Delivery',
  },
  {
    lookupId: 602,
    type: 'PaymentType',
    text: 'Debit/Credit Card',
    value: 'Debit/Credit Card',
  },
];
export const ORDER_STATUS = [
  {
    lookupId: 501,
    type: 'OrderStatus',
    text: 'Pending',
    value: 'Pending',
  },
  {
    lookupId: 502,
    type: 'OrderStatus',
    text: 'InProgress',
    value: 'InProgress',
  },
  {
    lookupId: 503,
    type: 'OrderStatus',
    text: 'Placed',
    value: 'Placed',
  },
  {
    lookupId: 504,
    type: 'OrderStatus',
    text: 'Waiting',
    value: 'Waiting',
  },
  {
    lookupId: 505,
    type: 'OrderStatus',
    text: 'Delivered',
    value: 'Delivered',
  },
];
export const NO_IMAGE_FOUND =
  "data:image/png;base64,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";
export default APP_SETTINGS;
